export default __webpack_public_path__ + "static/media/unit-testing.b12a8a4e.jpg";